import RailsResource from './rails-resource';

class NotificationService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'notifications',
      ajaxLoader: false
    });
  }

  read(notifierId) {
    return this.post(`${this.url}/${this.resource}/${notifierId}/read.json`, true);
  }

  unread(notifierId) {
    return this.post(`${this.url}/${this.resource}/${notifierId}/unread.json`, true);
  }

  readAll() {
    return this.post(`${this.url}/${this.resource}/read-all.json`, true);
  }

  readAllMentions() {
    return this.post(`${this.url}/mentions/read-all.json`, true);
  }
}

export default new NotificationService();